export const sortByCreated = (orders) =>
  orders.slice().sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

export default sortByCreated;
